import { gql } from '@apollo/client';

export const UPSERT_ACTIVITY_SESSION = gql`
  mutation upsertActivitySession($input: UpsertActivitySessionInput!) {
    session: upsertActivitySession(input: $input) {
      id
      sessionStatus
    }
  }
`;
